var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMrMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.616 14C1.168 14 0.786667 13.8427 0.472 13.528C0.157333 13.2133 0 12.8323 0 12.385V1.615C0 1.16833 0.157333 0.787333 0.472 0.472C0.786667 0.157333 1.168 0 1.616 0H18.385C18.8317 0 19.2127 0.157333 19.528 0.472C19.8427 0.786667 20 1.168 20 1.616V12.385C20 12.8317 19.8427 13.2127 19.528 13.528C19.2133 13.8427 18.8323 14 18.385 14H1.616ZM2.5 1H1.615C1.43567 1 1.28833 1.05767 1.173 1.173C1.05767 1.28833 1 1.436 1 1.616V12.385C1 12.5643 1.05767 12.7117 1.173 12.827C1.28833 12.9423 1.436 13 1.616 13H2.5V1ZM3.5 13H16.5V1H3.5V13ZM17.5 1V13H18.385C18.5643 13 18.7117 12.9423 18.827 12.827C18.9423 12.7117 19 12.5643 19 12.385V1.615C19 1.43567 18.9423 1.28833 18.827 1.173C18.7117 1.05767 18.5643 1 18.385 1H17.5Z",
    fill: "#EE2B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrMobile);
export default __webpack_public_path__ + "static/media/mr-mobile.ace6587431b1b3f70c5ecde0ab2d48c7.svg";
export { ForwardRef as ReactComponent };